import { parseBooleanValue } from "../../util";
import { IRegistryInstitution } from "../../organisations/model/RegistryInstitution";

const RegistryInstitutionParamMapper = (item: IRegistryInstitution) => {
  return {
    ...item,
    vazi: parseBooleanValue(item.valid),
    sifra: item.code,
    naziv: item.name,
    opis: item.description
  };
};

export default RegistryInstitutionParamMapper;
